// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__rWGto","darkModeButton":"Sidebar_darkModeButton__uHjQQ"};